import { clampDepartureDate } from '../logic/clampDepartureDate';

// The trip's search filters and the library's, shared by both apps. A
// departure date the API would refuse is clamped on every write.
export interface FiltersSlice {
  tripFilters: any;
  libraryFilters: any[];
  setTripFilters: (updater: any) => void;
  setLibraryFilters: (updater: any) => void;
}

// A departure date in the past is replaced by today at noon.
function clampTripFilters(filters: any) {
  if (!filters?.departureDate) return filters;
  return {
    ...filters,
    departureDate: clampDepartureDate(new Date(filters.departureDate)),
  };
}

const createSetTripFilters = (set: any) => (updater: any) =>
  set(
    (state: any) => {
      const next =
        typeof updater === 'function' ? updater(state.tripFilters) : updater;
      // An updater that keeps the filters changes nothing: clamping would
      // hand out a new object, and effects that depend on it would loop.
      if (next === state.tripFilters) return state;
      return { tripFilters: clampTripFilters(next) };
    },
    false,
    'setTripFilters',
  );

const createSetLibraryFilters = (set: any) => (updater: any) =>
  set(
    (state: any) => ({
      libraryFilters:
        typeof updater === 'function' ? updater(state.libraryFilters) : updater,
    }),
    false,
    'setLibraryFilters',
  );

export const createFiltersSlice = (set: any): FiltersSlice => ({
  tripFilters: null,
  libraryFilters: [],

  setTripFilters: createSetTripFilters(set),
  setLibraryFilters: createSetLibraryFilters(set),
});
